module.exports = __webpack_public_path__ + "static/flow2-7c378203e4e18404948b8e872998170f.png";